<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer" *ngIf="!isLoading">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Formula Builder Specification - {{componentDetails.componentUniqueId}}
  </div>
  <div class="modelBody formula-screen">
    <form #connectorSpecificationForm="ngForm">
      <div class="pl-4 pr-4">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12">
            <div class="row mb-2 formula-options">
              <div class="col-sm-12 row branchingContainer">
                <div class="parameterContainer">
                  <label for="selectedFormula" class="parameterName">
                    <strong>Formula</strong>
                    <span class="text-danger star-danger">*</span>
                  </label>
                  <div class="parameterOption">
                    <ng-multiselect-dropdown class="selectFormulaDwn" [placeholder]="'Select Formula'" [settings]="dropdownSettings"
                      [data]="formulaListDetails" [disabled]="readOnly" [(ngModel)]="selectedFormula"
                      name="selectedFormula" ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <button class="saveBtn2 actionBtn" [disabled]="!selectedFormula || readOnly"
                  (click)="saveFormulaListDetails()">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">

        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>